export default __webpack_public_path__ + "static/media/chevron.32929a63.svg";